/* BIANCO DI SOLE — Barra de progreso de la galería en móvil (PDP)
   En < 768px la galería de main-product es un carrusel Flickity (watchCSS).
   No usamos su API: observamos la clase `is-selected` que Flickity pone en
   la celda activa y movemos un segmento de ancho 1/n. En escritorio la barra
   se oculta por CSS (bds-product-pdp.css). */
(function () {
  function init() {
    var media = document.querySelector('.t4s-main-product__content [data-main-media]');
    if (!media || media.dataset.bdsProgress) return;
    media.dataset.bdsProgress = '1';

    var group = media.closest('[data-product-single-media-group]') || media;
    var bar = document.createElement('div');
    var thumb = document.createElement('span');
    bar.className = 'bds-gallery-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.appendChild(thumb);
    group.insertAdjacentElement('afterend', bar);

    var frame = 0;
    function update() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        var cells = Array.prototype.slice.call(media.querySelectorAll('[data-main-slide]:not(.is--media-hide)'));
        var n = cells.length;
        bar.hidden = n < 2;
        if (n < 2) return;
        var i = cells.findIndex(function (c) { return c.classList.contains('is-selected'); });
        thumb.style.width = (100 / n) + '%';
        thumb.style.transform = 'translateX(' + (Math.max(i, 0) * 100) + '%)';
      });
    }

    new MutationObserver(update).observe(media, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
